"use strict";
exports.__esModule = true;
exports.chart_errorbar_data_Fill = {
  "name": "--pf-chart-errorbar--data--Fill",
  "value": "transparent",
  "var": "var(--pf-chart-errorbar--data--Fill, transparent)"
};
exports["default"] = exports.chart_errorbar_data_Fill;